<template>
  <div v-if="sidebarOpen" class="sidebar-overlay" @click="closeSidebar"></div>
  <aside class="sidebar" :class="{ 'sidebar-open': sidebarOpen }">
    <div class="logo-area">
      <div class="logo-mark">Z</div>
      <span>智磐 AI</span>
    </div>

    <div class="nav-menu">
      <div class="nav-group-title">工作区</div>
      <div
        class="nav-item"
        :class="{ active: isActive('remove') }"
        @click="goAndClose('/remove')"
      >
        <svg class="icon" viewBox="0 0 24 24">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        抠图工作台
      </div>
      <div
        class="nav-item"
        :class="{ active: isActive('promo') }"
        @click="goAndClose('/promo')"
      >
        <svg class="icon" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M8 12l3 3 5-6"></path>
        </svg>
        宣传图生成
      </div>
      <div
        class="nav-item"
        :class="{ active: isActive('fission') }"
        @click="goAndClose('/fission')"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M2 12h4l2-9 5 18 2-9h5"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
        裂变图生成
      </div>
      <div
        class="nav-item"
        :class="{ active: isActive('amazonCopy') }"
        @click="goAndClose('/amazon-copy')"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          ></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        Amazon文案
      </div>
      <div
        class="nav-item"
        :class="{ active: isActive('keywordRadar') }"
        @click="goAndClose('/keyword-radar')"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M13 2L3 14h9l-1 8 10-10h-9l1-8z"></path>
        </svg>
        流量雷达
      </div>
      <div
        class="nav-item"
        :class="{ active: isActive('sizeChart') }"
        @click="goAndClose('/size-chart')"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M21 21H3V3"></path>
          <path d="M21 9L15 15L11 11L3 19"></path>
        </svg>
        中外转换工作台
      </div>
      <div
        class="nav-item"
        :class="{ active: isActive('promoVideo') }"
        @click="goAndClose('/promo-video')"
      >
        <svg class="icon" viewBox="0 0 24 24">
          <polygon points="5 3 19 12 5 21 5 3"></polygon>
        </svg>
        宣传视频生成
      </div>

      <!-- <div class="nav-group-title">文档</div>
      <div
        class="nav-item"
        :class="{ active: isActive('docs') }"
        @click="goAndClose('/docs')"
      >
        <svg class="icon" viewBox="0 0 24 24">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </svg>
        API / 使用说明
      </div> -->
    </div>
  </aside>
</template>

<script setup>
import { inject } from "vue";
import { useRouter } from "vue-router";
import { useNavStore } from "@/stores/useNavStore";

const navStore = useNavStore();
const router = useRouter();

const sidebarOpen = inject("sidebarOpen");
const closeSidebar = inject("closeSidebar");

const isActive = (key) => navStore.activeNav === key;

const goAndClose = (path) => {
  router.push(path);
  closeSidebar();
};
</script>
